// tslint:disable-next-line
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import Dialog from '@mui/material/Dialog';

import {
  buttonClose,
  charcoalGrey,
  paywallModalCloseButtonZIndex,
  sizeMobile,
  sizeTablet,
  steelGrey,
  zendeskHelperZIndex,
} from '~/styles';

const topMargin = '20px';
const bottomMargin = '20px';
export const Modal = styled(Dialog)`
  overflow-y: auto;
  z-index: ${zendeskHelperZIndex + 100};
  .MuiPaper-root {
    overflow: visible;
    margin-left: 20px;
    margin-right: 20px;
    margin-top: calc(var(--Header-Height) + ${topMargin});
    margin-bottom: ${bottomMargin};
    max-height: calc(100% - var(--Header-Height) - ${topMargin} - ${bottomMargin});
    width: 500px;
    ${sizeMobile(css`
      top: -5%;
      padding-top: 25px;
    `)};
  }
  .MuiDialog-container {
    height: auto;
  }
`;

export const ModalContentWrapper = styled.div`
  position: relative;
  background-color: #fff;
  color: ${charcoalGrey};
  border-radius: 2px;
  box-shadow: 0 2px 3px 0 rgba(36, 25, 25, 0.3);
  height: auto;
  text-align: center;
  border-radius: 5px;

  ${sizeTablet(css``)};

  ${sizeMobile(css`
    width: 100%;
    padding-bottom: 25px;
  `)};
`;

export const CloseButton = styled.button`
  ${buttonClose};
  z-index: ${paywallModalCloseButtonZIndex};
  position: absolute;
  top: 30px;
  right: 30px;
  height: 25px;
  width: 25px;
  &::before,
  &::after {
    background-color: ${steelGrey};
  }
  ${sizeMobile(css`
    top: 8px;
  `)}
`;
